// Central content for the Avatar Group site

export const TANK_ORANGE =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/qr492cd8_Photoroom_20260726_101726.png";
export const TANK_ORANGE_ALT =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/sgdvlztp_1D9FEE17-BB52-428E-9D06-5898FE32FB37.png";
export const TANK_WHITE =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/7nezqj4p_9A943C02-DBE8-40FB-9A04-2339532B9333.png";
export const GUARD_POSTER =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/l9mizrs1_14268834-66F1-4809-903A-7A155B9833D6.png";
export const SOUTH_INDIA_MAP =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/9txe9myz_Photoroom_20260518_112154.webp";
export const SELF_CLEAN_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/dcvv57w2_51A6A840-D9AE-45A8-83EA-3C11EC8DA1BB.png";
export const PURE_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/17rxktc9_IMG_8117.jpeg";
export const FOAM_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/w6hs3dnb_IMG_8118.jpeg";
export const HERO_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/09wsv3u0_111C651A-1EDA-48F1-B7E8-62B199D4722A.webp";
export const LOGO_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/km4ez9ls_Photoroom_20260726_112023.webp";
export const GROWTH_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pure-storage/artifacts/xb992tt9_CC950F75-8BC5-46DD-B237-229065183B42.jpeg";

export const DIMENSIONS = [
  { litre: 500, height: 40, width: 34 },
  { litre: 750, height: 45.5, width: 39 },
  { litre: 1000, height: 51, width: 42.5 },
  { litre: 1500, height: 52.5, width: 50 },
  { litre: 2000, height: 67.5, width: 52 },
  { litre: 3000, height: 73.5, width: 62 },
  { litre: 5000, height: 82, width: 76.5 },
];

export const NETWORK_CITIES = [
  "Chennai", "Bengaluru", "Coimbatore", "Madurai", "Trichy", "Salem",
  "Ernakulam", "Mangalore", "Mysore", "Tirupathi", "Vellore", "Erode",
  "Thoothukudi", "Karaikal", "Thiruvananthapuram", "Thrissur", "Karur", "Dindigul",
];

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Technology", href: "#technology" },
  { label: "Manufacturing", href: "#manufacturing" },
  { label: "Dealers", href: "#dealers" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const PRODUCTS = [
  {
    id: "self-clean",
    name: "Avatar Self Clean",
    layers: 5,
    tagline: "The pinnacle of hygiene.",
    description:
      "5-layer Self Clean technology automatically maintains water freshness — unparalleled convenience with zero manual cleaning.",
    features: ["Self-Clean Technology", "UV Stabilized Outer", "Anti-Bacterial Inner", "Anti-Algae Black Layer"],
    band: "#E53935",
    swatch: "#0B2E63",
    image: SELF_CLEAN_IMG,
    poster: true,
  },
  {
    id: "foam",
    name: "Avatar Foam",
    layers: 5,
    tagline: "Advanced foam insulation.",
    description:
      "A 5-layer wall with advanced foam insulation that keeps stored water noticeably cooler, even through peak summer heat.",
    features: ["Foam Insulation", "Keeps Water Cool", "UV Protection", "Food-Grade Inner"],
    band: "#071C3F",
    swatch: "#FFFFFF",
    image: FOAM_IMG,
    poster: true,
  },
  {
    id: "guard",
    name: "Avatar Guard",
    layers: 4,
    tagline: "4 layers of advanced protection.",
    description:
      "Inner white antimicrobial layer powered by silver nanotechnology, with a middle black layer engineered for algae prevention.",
    features: ["Silver Nanotech Inner", "Algae Prevention", "Thermal Blue Layer", "Reflective Outer"],
    band: "#F6B21A",
    swatch: "#F6B21A",
    image: GUARD_POSTER,
    poster: true,
  },
  {
    id: "pure",
    name: "Avatar Pure",
    layers: 3,
    tagline: "Strong outside. Pure inside.",
    description:
      "Food-grade inner layer with UV protection and fresh-air ventilation for pure, safe and hygienic storage every day.",
    features: ["Food-Grade Inner", "UV Protection", "Air Ventilation", "Hygienic Storage"],
    band: "#E53935",
    swatch: "#FFFFFF",
    image: PURE_IMG,
    poster: true,
  },
];

export const TECH_LAYERS = [
  {
    n: "01",
    title: "UV Protection",
    desc: "A UV-stabilized outer shell reflects sunlight and resists degradation for long-life durability.",
    color: "#F6B21A",
  },
  {
    n: "02",
    title: "Heat Resistance",
    desc: "Advanced foam insulation regulates temperature, keeping stored water noticeably cooler.",
    color: "#E53935",
  },
  {
    n: "03",
    title: "Anti-Algae Layer",
    desc: "A dedicated black layer blocks sunlight from entering, halting algae formation completely.",
    color: "#151515",
  },
  {
    n: "04",
    title: "Structural Strength",
    desc: "A reinforced core wall gives the tank its rugged, engineered-to-last structural integrity.",
    color: "#071C3F",
  },
  {
    n: "05",
    title: "Self-Clean Technology",
    desc: "The antimicrobial food-grade inner layer actively prevents bacteria, keeping water pure.",
    color: "#3A8DDE",
  },
];

export const REGIONS = ["Tamil Nadu", "Kerala", "Andhra Pradesh", "Karnataka"];

export const STATS = [
  { value: "5", label: "Layer Protection Technology" },
  { value: "100%", label: "Food-Grade Virgin Material" },
  { value: "ISO", label: "Certified Manufacturing" },
  { value: "4+", label: "States & Growing Network" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Strong Outside.",
    body: "Every Avatar tank is engineered from the shell inward — a UV-stabilized exterior built to withstand years of relentless sun, heat and weather.",
  },
  {
    n: "02",
    title: "Pure Inside.",
    body: "Food-grade, antimicrobial inner walls protect what matters most. Water that stays clean, safe and hygienic, drop after drop.",
  },
  {
    n: "03",
    title: "Engineered to Last.",
    body: "Careful planning, efficient execution and obsessive quality control. We build storage that families trust for a generation.",
  },
];

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1657368567304-5a2644b6052e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHx3YXRlciUyMHNwbGFzaGluZyUyMHB1cmUlMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODUwMzk3MTF8MA&ixlib=rb-4.1.0&q=85",
    caption: "Pure & Safe",
  },
  {
    url: "https://images.unsplash.com/photo-1776042675777-3802f02f816e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwcHVyZSUyMHdhdGVyJTIwZHJvcHxlbnwwfHx8fDE3ODUwMzk3MTF8MA&ixlib=rb-4.1.0&q=85",
    caption: "Every Drop Counts",
  },
  {
    url: "https://images.pexels.com/photos/18568174/pexels-photo-18568174.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Built at Scale",
  },
  {
    url: "https://images.unsplash.com/photo-1657368567304-5a2644b6052e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHx3YXRlciUyMHNwbGFzaGluZyUyMHB1cmUlMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODUwMzk3MTF8MA&ixlib=rb-4.1.0&q=85",
    caption: "Modern Homes",
  },
];

export const MANUFACTURING_IMG =
  "https://images.pexels.com/photos/18568174/pexels-photo-18568174.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1600";
